import { getReport } from "@/services/report.svc"

const defaultState = () => ({
    data: [],
    headers: [
        {
            text: 'Full Name',
            value: 'EmployeeName',
            sortable: true
        },
        {
            text: 'Job',
            value: 'JobNumber',
            sortable: true
        },
        {
            text: 'Est Labor',
            value: 'EstLabor',
            sortable: false
        },
        {
            text: 'Est OT',
            value: 'EstOt',
            sortable: false
        },
        {
            text: 'Act Labor',
            value: 'ActLabor',
            sortable: false
        },
        {
            text: 'Act OT',
            value: 'ActOt',
            sortable: false
        },
        {
            text: 'Comments',
            value: 'Comments',
            sortable: false
        },
    ]
})

export default {
    namespaced: true,
    state: defaultState(),

    actions: {
        async setReport({ commit }, payload) {
            const report = await getReport(payload)
            commit('SET_DATA', report)
        },
    },

    getters: {
        data: (state) => state.data,
        headers: (state) => state.headers,
    },

    mutations: {
        SET_DATA(state, payload) {
            state.data = payload
        }
    }
}